import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Factory, Ruler, Target } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
function TiltCard({
  icon: Icon,
  title,
  desc,
  delay
}: {
  icon: any;
  title: string;
  desc: string;
  delay: number;
}) {
  const [rotate, setRotate] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const card = e.currentTarget;
    const box = card.getBoundingClientRect();
    const x = e.clientX - box.left;
    const y = e.clientY - box.top;
    const centerX = box.width / 2;
    const centerY = box.height / 2;
    const rotateX = (y - centerY) / 20;
    const rotateY = (centerX - x) / 20;
    setRotate({
      x: rotateX,
      y: rotateY
    });
  };
  const handleMouseLeave = () => {
    setRotate({
      x: 0,
      y: 0
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.5
  }} className="perspective-1000" data-id="element-157">
      <motion.div onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} animate={{
      rotateX: rotate.x,
      rotateY: rotate.y
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 20
    }} className="bg-white/5 border border-white/10 p-8 rounded-2xl h-full hover:border-purple-500/50 hover:bg-white/[0.07] transition-colors relative overflow-hidden group preserve-3d" data-id="element-158">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-159" />

        <div className="w-14 h-14 bg-purple-900/30 rounded-xl flex items-center justify-center mb-6 text-purple-400 group-hover:scale-110 transition-transform duration-300 border border-purple-500/20" data-id="element-160">
          <Icon className="w-7 h-7" data-id="element-161" />
        </div>

        <h3 className="text-xl font-bold mb-4 text-white group-hover:text-purple-200 transition-colors" data-id="element-162">
          {title}
        </h3>
        <p className="text-gray-400 leading-relaxed text-sm md:text-base" data-id="element-163">
          {desc}
        </p>
      </motion.div>
    </motion.div>;
}
export function MechanismSection() {
  return <section className="py-24 bg-[#050505]" data-id="element-164">
      <div className="container mx-auto px-4" data-id="element-165">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-166">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-167">
            Ok, pero… ¿qué hace a esto distinto?
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-168">
            La diferencia no es "usar IA". La diferencia es el{' '}
            <span className="text-white font-bold" data-id="element-169">mecanismo</span>:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-170">
          <TiltCard icon={Factory} title="1) Volumen industrial" desc="100 creativos en minutos (no en días). Tu semana de testing aparece de golpe. Olvidate del cuello de botella creativo." delay={0} data-id="element-171" />
          <TiltCard icon={Ruler} title="2) Multi-ángulo real" desc="No te tira variaciones cosméticas. Te genera ángulos distintos: dolor, deseo, objeción, transformación, urgencia." delay={0.2} data-id="element-172" />
          <TiltCard icon={Target} title="3) Diseñado para productos digitales" desc="Ebooks y cursos se venden con: claridad + promesa + prueba + emoción. No con 'diseñitos' bonitos que no convierten." delay={0.4} data-id="element-173" />
        </div>
      </div>
    </section>;
}